module.exports = __webpack_public_path__ + "static/media/close-hover.7aa1c514.svg";